export default {
    install(Vue, options) {
        //签名算法sign
        Vue.prototype.handleSign = function (params) {
            let newKeys = Object.keys(params).sort()
            let newObj = {}
            newKeys.map(item => newObj[item] = params[item])
            let string1 = ''
            for (var key in newObj) {
                string1 += key + '=' + newObj[key] + '&'
            }
            return string1.substring(0, string1.length - 1) + this.$global.signKey
        }

        //当前时间戳（yyyyMMddHHmmss）
        Vue.prototype.timestamp = function () {
            let year = new Date().getFullYear()
            let month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
            let date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
            let hours = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
            let minutes = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
            let seconds = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
            return '' + year + month + date + hours + minutes + seconds
        }

        //获取用户信息
        Vue.prototype.getMemberInfo = function () {
            return new Promise ((resolve, reject) => {
                this.$post({
                    method: 'member.info.get',
                    auth_code: this.getLocal('auth_code')
                }).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }

        //设置localStorage
        Vue.prototype.setLocal = function (name, value) {
            localStorage.setItem(name, JSON.stringify(value));
        }

        //获取localStorage
        Vue.prototype.getLocal = function (name) {
            return JSON.parse(localStorage.getItem(name));
        }

        //删除localStorage
        Vue.prototype.removeLocal = function (name) {
            localStorage.removeItem(name);
        }

    }
}


// WEBPACK FOOTER //
// ./src/common/js/global.js